export const NEWSBOARD_POST_PROFILE_TAB_COMMENTS = 'comments'
